@if(visible()){
<div> <!-- class="jk-datefield-border" -->
  <div [ngStyle]="flexStyle">
    <div>
      <app-jkfieldlabel [displayLabel]="displayLabel()" [label]="label()" [required]="required()"
        [emojiLabel]="emojiLabel()"></app-jkfieldlabel>
    </div>
    <div class="jk-margin0">
      @if(readonly()){
      <input matInput [value]="date | date:'yyyy/MM/dd' " [readonly]="readonly()">
      }@else {
      <mat-form-field class="jk-datefield">
        <input matInput [matDatepicker]="picker" [(ngModel)]="date" (ngModelChange)="onValueChanged($event)">
        <mat-datepicker-toggle matIconSuffix [for]="picker">
          <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
        </mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
      }
    </div>
  </div>
</div>
}
<!-- <table class="jk-margin0">
  <tr class="jk-margin0">
    <app-jkfieldlabel [displayLabel]="displayLabel" [label]="label()" [required]="required"></app-jkfieldlabel>
  </tr>
  <tr>
    <table class="jk-margin0">
      <tr class="jk-margin0">
        <td>
          @if(readonly()){
          <input matInput [value]="date | date:'yyyy/MM/dd' " [readonly]="readonly()">
          }@else {
          <mat-form-field class="jk-datefield">
            <input matInput [matDatepicker]="picker" [(ngModel)]="date" (ngModelChange)="onValueChanged($event)">
            <mat-datepicker-toggle matIconSuffix [for]="picker">
              <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
            </mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
          }
        </td>
      </tr>
    </table>
  </tr>
</table> -->